import {RoleId} from '@/entities/role';
import {Policy} from '@/policies';


export interface AdminPolicyContext {
  userRoleId: unknown;
}

export function isAdminPolicyContext(obj: unknown): obj is AdminPolicyContext {
  const tmp = obj as AdminPolicyContext;

  return tmp.userRoleId !== undefined;
}

export const adminPolicy: Policy = {
  async can(context: unknown) {
    if (!isAdminPolicyContext(context)) {
      return false;
    }
    return context.userRoleId == RoleId.SuperAdmin ||
      context.userRoleId == RoleId.Admin;
  }
}
